import { consumptionAPI } from "./clients";
const END_POINT = "/entity_list";

const getStaticEntities = payload => {
  return consumptionAPI.post(END_POINT, payload);
};

export { getStaticEntities };
